import cn from 'classnames';

export function Column({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'w-full overflow-y-auto border-0 border-r border-solid border-r-gray-300 last-of-type:border-r-0',
        className,
      )}
    >
      {children}
    </div>
  );
}
